// extracted by mini-css-extract-plugin
export var active = "_hw-2";
export var recordingDot = "_hw-1";
export var recordingIndicator = "_hw-0";